<template>
  <div class="main-page">
    <Navigation
      v-model="drawer"
      :menus="menus"
      :options="storeGetProjectMenus"
      @clickMenu="clearProjectMenus"
      @clickOption="clickOption"
      :currentOption="storeGetCurrentOption.text"
      v-show="!statusConferenceRoom"
    />
    <Toolbar
      v-model="drawer"
      title="1Life Systems"
      :firstName="user.first_name"
      :lastName="user.last_name"
      :image="user.image"
      :subtitle="user.phone"
      :notifications="notifications"
      v-show="!statusConferenceRoom"
    />
    <div class="meet-layout" v-show="statusConferenceRoom">
      <receiveCallingVue v-model="credential" ref="call" @end="EndCalling" disableRecordBtn disableAutoLeave disableSharedScreenBtn :displayInvitedToMeetingBtn="false" :setRole="false"/>
        <!-- <u-user-calling v-model="credential" ref="call" @end="EndCalling" disableRecordBtn disableAutoLeave disableSharedScreenBtn :displayInvitedToMeetingBtn="false" :setRole="false"/> -->
    </div>
    <v-dialog
      v-model="dialogInvitedMeeting"
      max-width="400"
      persistent
      content-class="my-custom-dialog"
    >
      <v-card>
        <div class="pa-5 d-flex align-center justify-center">
          <!-- <div class="call-animation">
              <v-icon>mdi-close</v-icon>
          </div> -->
            <div class="profile-pic">
                  <v-icon color="#20409C">mdi-phone</v-icon>
                </div>
            <div class="ml-5">
              <!-- <div class="d-flex justify-center">
                <div class="profile-pic mb-5">
                  <v-icon color="#20409C">mdi-phone</v-icon>
                </div>
              </div> -->
              <div style="font-weight: 700; font-size: 18px; color: #333333;">
                ติดต่อ Consult
              </div>
              <div style="font-weight: 400; font-size: 16px; color: #636363;">
                คุณได้รับคำเชิญให้เข้าร่วมการประชุม
              </div>
            </div>
        </div>
        <div class="d-flex justify-center">
          <v-btn
ฃ                  dark
                  color="green"
                  style="
                    background: #ffffff;
                    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08),
                      0px 0.5px 2px rgba(96, 97, 112, 0.16);
                    border-radius: 8px;
                    margin: 8px;
                  "
                  @click="StartMeet()"
                >
                  <v-icon class="mr-3">mdi-phone</v-icon>
                  เข้าร่วม
                </v-btn>
           <!-- <v-btn icon class="btn-call">
            <v-icon v-icon>mdi-phone</v-icon>
          </v-btn> -->
           <v-btn
ฃ                  dark
                  color="red"
                  style="
                    background: #ffffff;
                    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08),
                      0px 0.5px 2px rgba(96, 97, 112, 0.16);
                    border-radius: 8px;
                    margin: 8px;
                  "
                  @click="Close()"
                >
                  <v-icon class="mr-3">mdi-phone-hangup</v-icon>
                  ยกเลิก
                </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-main class="main-content">
      <v-container class="main-container pa-4">
        <transition name="fade" mode="out-in">
          <router-view style="height: 100%" class="padding-layout-main"></router-view>
        </transition>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import Toolbar from '../components/Layout/ToolBar.vue'
import Navigation from '../components/Layout/Navigation.vue'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import receiveCallingVue from '@/components/conference/receiveCalling.vue'
export default {
  components: {
    Toolbar,
    Navigation,
    receiveCallingVue
  },
  computed: {
    ...mapGetters(['storeGetProjectMenus', 'storeGetCurrentOption'])
  },
  created () {
    this.initUserInfo()
    this.initMenuNavigation()

    // NOTE สำหรับแก้ปัญหา Event ไม่เคลียเมื่อมีการ Refresh Page
    this.$websocket.Disconnect()

    // NOTE สำหรับ Connect Websocket
    this.$websocket.Connect(localStorage.getItem('Accesstoken'))
    // รับค่า การแจ้งเตือนจาก pop up
    this.$websocket.$on('calling', (val) => {
      // this.showMeetPopUp(val)
      this.dialogInvitedMeeting = true
      this.channelMeeting = val
    })
  },

  data () {
    return {
      drawer: true,
      menus: [],
      notifications: [],
      user: {
        user_id: '',
        first_name: '',
        last_name: '',
        phone: '',
        image: ''
      },
      credential: { token: '', appid: '', channel: '', uid: '', features: [] },
      statusConferenceRoom: false,
      dialogInvitedMeeting: false,
      channelMeeting: ''

    }
  },
  methods: {
    ...mapMutations(['storeSetUserinfo', 'storeSetCurrentOption']),
    ...mapActions(['clearProjectMenus']),
    async initUserInfo () {
      const res = await this.getUserInfo()
      if (res.status) {
        this.user = res.data
        this.storeSetUserinfo(res.data)
      } else {
        this.antmessage.error(res.message)
      }
    },
    async initMenuNavigation () {
      const res = await this.getMenusForNavigation()
      if (res.status) {
        const data = res.data.map((x) => {
          return {
            ...x,
            ...{
              to: { name: x.name },
              items: x.items.map((y) => {
                return { ...y, ...{ to: { name: y.name } } }
              })
            }
          }
        })

        // TODO Add Profile And Notification is here ---------------
        const appendDefaultMenu = [
          // Profile
          {
            create_by_system: false,
            name: 'profilePage',
            description: '',
            index: 0,
            path: '',
            to: { name: 'profilePage' },
            text: 'โปรไฟล์',
            icon: 'mdi-account-outline',
            items: []
          },
          // Notification
          {
            create_by_system: false,
            name: 'notificationPage',
            description: 'notification',
            index: 0,
            path: '',
            to: { name: 'notificationPage' },
            text: 'แจ้งเตือน',
            icon: 'mdi-bell-outline',
            items: []
          }
        ]
        // TODO ----------------------------------------------------
        this.menus = [...data, ...appendDefaultMenu]

        // REMOVE LOCAL MENU
        this.menus = this.menus.filter((obj) => {
          return obj.text !== 'APIs' && obj.text !== 'งาน'
        })

        if (
          this.$router.currentRoute.path === '/home' &&
          this.menus.length !== 0
        ) {
          this.$router.push({ name: this.menus[0].name }).catch(() => {})
        }
      } else {
        this.antmessage.error(res.message)
      }
    },
    clickOption (item) {
      this.storeSetCurrentOption(item)
    },
    async StartMeet () {
      try {
        // this.credential = await this.GetAgoraCredentialGroup2(channel)
        const res = await this.GetAgoraCredentialGroupForJoinRoom(this.channelMeeting)
        this.credential = res.data
        this.statusConferenceRoom = true
        // ปิด dialog
        this.dialogInvitedMeeting = false
        await this.$refs.call.clickJoin()
      } catch (err) {
        // this.checkStateClickState =
        this.dialogInvitedMeeting = false
        this.$notification.error({
          message: 'Error',
          description: err.message,
          placement: 'bottomRight'
        })
      }
    },
    async EndCalling () {
      // this.status = true
      this.statusConferenceRoom = false
      this.credential = {
        appid: '',
        token: '',
        channel: '',
        uid: '',
        features: []
      }
    },
    Close () {
      this.dialogInvitedMeeting = false
    }
  }
}
</script>

<style scoped>
.main-page {

  height: 100vh;
  overflow: hidden;
}
::v-deep .main-content {
  /* background: #F5F7FF; */
  background: #eaedf7;
  width: 100%;
  height: 100%;

}
.padding-layout-main{
  padding: 20px;
  border-radius: 8px;
  /* background: #F5F7FF; */
  background: #ffff;

}
>>> .main-container {
  width: 100%;
  height: 100%;
}
/* Router Transition https://markus.oberlehner.net/blog/vue-router-page-transitions/ */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-out;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
  transition: 0.5s;
  transform: translateX(800px);
  animation: 0.5s infinite;
}
.meet-layout {
  /* background: #f6f8ff; */
  /* background: #4a5dad; */

  width: 100%;
  height: 100%;
  z-index: 99;
}
    .container {
        max-width: 100%;
    }
>>> .my-custom-dialog {
    /* align-self: flex-end; */
    position: absolute;
    bottom: 0;
    right: 0;

    background: rgba(32, 63, 156, 0.779);
    backdrop-filter: blur(6px);
    /* Note: backdrop-filter has minimal browser support */
    border-radius: 12px;
  }
.btn-call{
  background: #2ECF56;
}

.call-animation {
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
     width: 30px;
    height: 30px;
    position: relative;
    margin: 0 auto;
    border-radius: 100%;
    border: solid 2px #20409C;
    animation: play 1.6s ease infinite;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    backface-visibility: hidden;
    box-shadow: 0 0 0 12px rgba(55, 218, 180, 0.3), 0 0 0 20px rgb(255, 255, 255);

}
@keyframes play {

    0% {
        transform: scale(1);
    }
    15% {
        box-shadow: 0 0 0 5px rgba(17, 88, 241, 0.1), 0 0 0 5px rgb(255, 255, 255,0.3);
    }
    20% {
        box-shadow: 0 0 0 10px rgba(17, 88, 241, 0.2), 0 0 0 15px rgb(255, 255, 255,0.5);
    }
    35% {
        box-shadow: 0 0 0 12px rgba(17, 88, 241, 0.3), 0 0 0 20px rgb(255, 255, 255,0.7);
    }

}

.profile-pic {
    width: 50px;
    aspect-ratio: 1/1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    animation-name: glow;
    animation-duration: 3000ms;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    animation-timing-function: ease;
}

/* .profile {
    width: 50px;
    aspect-ratio: 1/1;
} */

@keyframes glow {

    50% {
              /* box-shadow: 0 0 0 12px rgba(17, 88, 241, 0.3), 0 0 0 20px rgb(255, 255, 255,0.7); */

        box-shadow: 0 0 10px 5px  #20409C;
    }
}
</style>
